const DefaultActionTypes = {
    CLOSE_PACIENTE_MODAL: 'default/closePacienteModal',
    INIT_CALL: 'default/initCall',
    OPEN_CHAT_ASSISTENTE: 'default/openChatAssistente',
    FULL_SCREEN_PACIENTE_MODAL: 'default/fullScreenPacienteModal',
};

export default DefaultActionTypes;